import { ApolloClient, NormalizedCacheObject } from '@apollo/client';

import { Logger } from '@eluve/logger-main';
import { updateSegmentEndedAtMutation } from '@eluve/shared-gql-operations';

import { TaskHandler, UpdateSegmentRecordingEndedAtEvent } from '../types';

export const updateSegmentHandler = ({
  client,
  logger,
}: {
  client: ApolloClient<NormalizedCacheObject>;
  logger: Logger;
}): TaskHandler<UpdateSegmentRecordingEndedAtEvent> => {
  return async (task, context) => {
    const segmentResult = await client.mutate({
      mutation: updateSegmentEndedAtMutation,
      variables: {
        appointmentId: task.appointmentId,
        tenantId: context.tenantId,
        segmentId: task.segmentId,
        recordingEndedAt: task.recordingEndedAt,
      },
      context: { fetchOptions: { signal: context.signal } },
    });
    if (segmentResult.errors) {
      logger.error('Updating segment endedAt failed', {
        errors: segmentResult.errors,
        appointmentId: task.appointmentId,
      });
      throw new Error('Failed to update segment endedAt');
    }
  };
};
